import React from 'react';
import { Link } from 'react-router-dom';
import { FaInfoCircle } from "react-icons/fa";
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Home.css';


const Home = () => {
  return (
    <div className="home">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <div className="brand-logos" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '32px', marginBottom: '24px' }}>
              <img src="/files/weltew-logo.png" alt="Weltew" className="logo-weltew" style={{ height: 112 }} />
              <img src="/files/bellona-logo.png" alt="Bellona" className="logo-bellona" style={{ height: 48 }} />
              <img src="/files/beko-logo.png" alt="Beko" className="logo-beko" style={{ height: 88 }} />
              <img src="/files/yatas-logo.png" alt="Yataş" className="logo-yatas" style={{ height: 112 }} />
            </div>
            <h1>Balcı Mobilya'ya Hoş Geldiniz</h1>
            <p>Kaliteli mobilya ve beyaz eşya çözümleri ile evinizi güzelleştirin</p>
            <div className="hero-buttons">
              <a className="btn btn-primary" href="tel:+902126251815">📞 Hemen Ara</a>
              <Link to="/kurumsal" className="btn btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <FaInfoCircle style={{ fontSize: '1.2em' }} />
                <span>Hakkımızda</span>
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features">
          <div className="container">
            <h2>Neden Balcı Mobilya?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🏠</div>
                <h3>Mobilya</h3>
                <p>En kaliteli malzemeler ve işçilik ile üretilen mobilyalarımız evinize değer katar.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⚡</div>
                <h3>Beyaz Eşya</h3>
                <p>Modern ve enerji tasarruflu beyaz eşya çözümleri ile yaşamınızı kolaylaştırın.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🛏️</div>
                <h3>Yatak + Baza + Başlık</h3>
                <p>Rahat ve konforlu uyku için özel tasarım yatak takımlarımızı keşfedin.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="categories">
          <div className="container">
            <h2>Ürün Kategorilerimiz</h2>
            <div className="categories-grid">
              <Link to="/mobilya" className="category-card">
                <div className="category-image mobilya-bg" style={{ backgroundImage: "url('/files/ana-sayfa-mobilya.webp')" }}>
                </div>
                <div className="category-content">
                  <h3>Mobilya</h3>
                  <p>Oturma odası, yatak odası, çalışma odası mobilyaları</p>
                  <div className="category-action">
                    <span className="action-text">Daha Fazla</span>
                    <span className="action-arrow">→</span>
                  </div>
                </div>
              </Link>
              
              <Link to="/beyaz-esya" className="category-card">
                <div className="category-image beyaz-esya-bg" style={{ backgroundImage: "url('/files/ana-sayfa-beyaz-esya.png')" }}></div>
                <div className="category-content">
                  <h3>Beyaz Eşya</h3>
                  <p>Buzdolabı, çamaşır makinesi, bulaşık makinesi</p>
                  <div className="category-action">
                    <span className="action-text">Daha Fazla</span>
                    <span className="action-arrow">→</span>
                  </div>
                </div>
              </Link>
              
              <Link to="/yatak-baza-baslik" className="category-card">
                <div className="category-image yatak-bg" style={{ backgroundImage: "url('/files/ana-sayfa-yatak.jpg')" }}></div>
                <div className="category-content">
                  <h3>Yatak + Baza + Başlık</h3>
                  <p>Konforlu uyku için özel tasarım yatak takımları</p>
                  <div className="category-action">
                    <span className="action-text">Daha Fazla</span>
                    <span className="action-arrow">→</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="about-preview">
          <div className="container">
            <div className="about-content">
              <div className="about-text">
                <h2>Balcı Mobilya Hakkında</h2>
                <p>35 yılı aşkın deneyimimizle, müşterilerimize en kaliteli mobilya ve beyaz eşya çözümleri sunuyoruz. Modern tasarımlar ve uygun fiyatlarla evinizi güzelleştiriyoruz.</p>
                <Link to="/kurumsal" className="btn btn-outline">Daha Fazla Bilgi</Link>
              </div>
              <div className="about-stats">
                <div className="stat">
                  <h3>35+</h3>
                  <p>Yıllık Deneyim</p>
                </div>
                <div className="stat">
                  <h3>5000+</h3>
                  <p>Mutlu Müşteri</p>
                </div>
                <div className="stat">
                  <h3>800+</h3>
                  <p>Ürün Çeşidi</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;